import { useError } from "../../context/useErrorContext"
import { PostRequest } from "../../services/ApiClientService"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { ERequestType } from "../../Enum/ERequestType"
import { EPixKeyType } from "../../Enum/EPixKeyType"
import { useTranslation } from "react-i18next"

export interface CompleteResellerProfileRequest {
  pixKeyType: EPixKeyType
  pixKey?: string
  bankName?: string
  bankAgency?: string
  bankAccount?: string
  bankAccountHolderName?: string
}

export const useCompleteResellerProfile = () => {
  const { t } = useTranslation("general")

  const { setError } = useError()

  const handleCompleteResellerProfile = async (request: CompleteResellerProfileRequest, onSuccess: () => void) => {
    try {
      const response = await PostRequest(API_ROUTES.RESELLER.COMPLETE_PROFILE, request, ERequestType.Reseller)

      if (!response.success) {
        throw new Error(response.message)
      }

      onSuccess()
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")

      setError(t("label_title_erro"), message)
    }
  }

  return { handleCompleteResellerProfile }
}
